import 'css-chunksrc/client/pages/documentsPage/reportsPage/loader/styles.scss';export default {
  "reportsList": "_reportsList_15gi8_1"
};